// extracted by mini-css-extract-plugin
export var errorsContainer = "_ta-1";
export var link = "_ta-0";